// @flow
import * as types from '../constants/action_types'
import { getCurrentTimestamp } from 'er2_web_utils'
import { collaborationIsEnabled } from './collaboration'
import * as wsTypes from '../modules/websockets/server/constants/action_types'
import type { AnalyzeFrameworkBarType } from '../reducers/analyze_framework_bar'

export type SettingsType = {
    historyCount?: number,
}
export const handledSetFicusConfig = () => ({ type: types.HANDLED_SET_FICUS_CONFIG })

const sendFicusConfigToSession = (config: AnalyzeFrameworkBarType, getState: Function, emit: Function) => {
    const state = getState()
    const payload = {
        applicationId: state.meta.name,
        timestamp: getCurrentTimestamp(),
        operation: {
            name: types.OT_SET_FICUS_CONFIG,
            originator: state.token.value,
            params: { config },
        },
    }
    if (collaborationIsEnabled(state) && !state.collaborationSettings.readOnly && state.collaboration.sharedState.propagateSetFicusConfig) {
        payload.roomId = state.collaboration.sharedState.token
        console.log(`emitting ${wsTypes.WS_CLIENT_ACTION}`)
        emit(wsTypes.WS_CLIENT_ACTION, payload)
    }
    handledSetFicusConfig()
}

export const setFicusConfig = (config: AnalyzeFrameworkBarType) => (dispatch: Function, getState: Function, { emit }) => {
    dispatch({ type: types.SET_FICUS_CONFIG, config })
    sendFicusConfigToSession(config, getState, emit)
}

export const updateIterationOrder = (iterationType: string) => (dispatch: Function, getState: Function) => {
    const config = getState().analyzeFrameworkBar.config
    const ficusData = getState().selectFrameworkBar.ficusData

    if (iterationType !== undefined && ficusData.themeType === 'raster') {
        // Default iteration order is from 0..nframes-1
        const sortFn = (a, b) => {
            if (a[0] !== null && b[0] === null) return -1
            if (a[0] === null && b[0] !== null) return 1
            if (a[0] === null && b[0] === null) return 0
            if (a[0] < b[0]) return -1; else if (a[0] > b[0]) return 1
            return 0
        }

        // ficusData.meta.grayswan is the total number of realizations
        console.warn('fix iteration calculation for temporal themes')
        let iterationOrder = ficusData.themes[0].meta.grayswan.map((m, i) => i)
        let values
        if (iterationType === 'value') {
            // Chart data is an array of [val, realization_raster_str]
            //   Append index to each array to get the indices of the sorted values.
            values = getState().analysisPanel.analysisLocation.values.map((v, i) => [...v, i])
        } else if (iterationType === 'grayswan') {
            // Gray swan is just a list of values corresponding to realization001, 002, etc
            console.warn('Using theme 1 for grayswan values')
            values = getState().selectFrameworkBar.ficusData.themes[0].meta.grayswan.map((v, i) => [...v, i])
        } else if (iterationType === 'valueGrayswan') {
            // Gray swan is just a list of values corresponding to realization001, 002, etc
            values = getState().analysisPanel.analysisLocation.valuesGrayswan.map((v, i) => [...v, i])
        }
        if (values) {
            iterationOrder = values.sort(sortFn).map(s => s[2])
            if (iterationType === 'grayswan' || iterationType === 'valueGrayswan') {
                // Sort from most gray swan to white.
                iterationOrder.reverse()
            }
        }

        dispatch(setFicusConfig({ ...config, iterationType, iterationOrder }))
    }
}

export const updateSettings = (newSettings: SettingsType) => ({ type: types.UPDATE_SETTINGS, newSettings })
